import { render, staticRenderFns } from "./BlogPostSettingsTabCoverImage.vue?vue&type=template&id=3929960c&"
import script from "./BlogPostSettingsTabCoverImage.vue?vue&type=script&lang=js&"
export * from "./BlogPostSettingsTabCoverImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports